import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import LocationsTabOnesingle from "./LocationTabsingle";
import "./homecss/locationtwo.css";
import { Button, Card } from "react-bootstrap";


//LocationTwo for sm screen and calls on Blc_LocationOne in Blc_Location Folder.

const LocationTwo = (props) => {

  // const cardIndex = (index) => {
  //   props.valIndex(index);
  // }

  return (
    <>
      <Container>
        <Row>
          {props.navDataph.map((val, index, idx) => (
            <Col className="locationPh" key={Math.random()}>
              <LocationsTabOnesingle blcs={val.blc_location_name} />
              {/* <LocationsTabOnesingle blcs={val.blc_location_name} locIndex={index} blcIndex={cardIndex} /> */}
            </Col>
          ))}
        </Row>
      </Container>
    </>
  );
};

export default LocationTwo;
